<div class="container">
  <div class="row row--justify-space-between row--align-center">
    <div class="logo">
      <div class="logo logo__app"></div>
      <div *ngIf="productLogo === true" class="product-logo"></div>
    </div>
  </div>
</div>
